import { render, staticRenderFns } from "./RiskIdentifyForm.vue?vue&type=template&id=1b1e7acd&scoped=true"
import script from "./RiskIdentifyForm.vue?vue&type=script&lang=js"
export * from "./RiskIdentifyForm.vue?vue&type=script&lang=js"
import style0 from "./RiskIdentifyForm.vue?vue&type=style&index=0&id=1b1e7acd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1e7acd",
  null
  
)

export default component.exports